import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {
  marketingMobileCuttoff
} from '@css/constants'

export const IframeSectionContainer = styled('div')(css`
  max-width: 1000px;
  margin: 0 auto;
`)

export const ModeContainer = styled('div')(css`
`);

export const Content = styled('div')(css`
  padding-top: 30px;
  padding-bottom: 60px;

  @media(max-width: ${marketingMobileCuttoff}) {
    padding-top: 0;
    padding-bottom: 0;
  }
`);

export const Iframe = styled('iframe')(css`
  width: 99%;
  max-width: 1000px;
  height: 800px;
  margin: auto;
  display: block;
`);
